const BLS_ROOT_DOMAIN = "thebuyerlistingservice.com";
const SLUG_PATTERN = /^[a-z0-9-]+$/;

// Where the widget sends visitors for a tenant. When the widget is served from
// that tenant's own host (e.g. lar-staging.thebuyerlistingservice.com for the
// "lar" tenant) links stay on that host, so staging widgets open staging. From
// any other host (the production embed origin) they go to the tenant's
// production host, <slug>.thebuyerlistingservice.com.
export const tenantOrigin = (slug, loc = window.location) => {
  const { protocol, host } = loc;
  if (host.includes("localhost")) {
    return `${protocol}//${slug}.${host.slice(host.indexOf("localhost"))}`;
  }
  if (SLUG_PATTERN.test(slug)) {
    const ownHost = new RegExp(
      `^${slug}(-[a-z0-9-]+)?\\.${BLS_ROOT_DOMAIN.replace(/\./g, "\\.")}$`,
    );
    if (ownHost.test(host)) return `${protocol}//${host}`;
  }
  return `${protocol}//${slug}.${BLS_ROOT_DOMAIN}`;
};
